import { createSlice } from "@reduxjs/toolkit";
import appApi from "../services/appApi";

export const userSlice = createSlice({
    name: "user",
    initialState: null,
    reducers: {
        addNotifications: (state, { payload }) => {
            if (state.newMessages[payload]) {
                state.newMessages[payload] = state.newMessages[payload] + 1;
            } else {
                state.newMessages[payload] = 1;
            }
        },
        resetNotifications: (state, { payload }) => {
            delete state.newMessages[payload];
        },
        // Replaces the entire user state (used after profile update)
        setUser: (state, { payload }) => {
            return payload;
        },
        // Patches specific profile fields after PUT /users/profile succeeds
        updateUser: (state, { payload }) => {
            if (!state) return state;
            const { name, picture, lastNameChangeAt, lastAvatarChangeAt } = payload;
            if (name !== undefined) state.name = name;
            if (picture !== undefined) state.picture = picture;
            if (lastNameChangeAt !== undefined) state.lastNameChangeAt = lastNameChangeAt;
            if (lastAvatarChangeAt !== undefined) state.lastAvatarChangeAt = lastAvatarChangeAt;
        },
    },

    extraReducers: (builder) => {
        // Register does NOT save user — user must verify OTP first

        // Save user after OTP verification succeeds (this is what logs them in)
        builder.addMatcher(appApi.endpoints.verifyOtp.matchFulfilled, (state, { payload }) => {
            if (payload.user) {
                return { ...payload.user, _id: payload.user.id || payload.user._id, newMessages: {} };
            }
            return payload;
        });

        // Save user after login
        builder.addMatcher(appApi.endpoints.loginUser.matchFulfilled, (state, { payload }) => {
            if (payload.user) {
                return { ...payload.user, _id: payload.user.id || payload.user._id, newMessages: {} };
            }
            return payload;
        });

        // Logout: destroy user session
        builder.addMatcher(appApi.endpoints.logoutUser.matchFulfilled, () => null);

        // Delete Account: destroy user session
        builder.addMatcher(appApi.endpoints.deleteAccount.matchFulfilled, () => null);
    },
});

export const { addNotifications, resetNotifications, setUser, updateUser } = userSlice.actions;
export default userSlice.reducer;
